<section>
  <div>
    <h1>Legal notice</h1>
    <button [ngClass]="[context]" (click)="back.emit()">
      <img src="assets/icons/back.svg" alt="back button">
    </button>
  </div>
  <h3>Imprint</h3>
  <p>
    Felicia Tretter <br />
    Wuppertaler Straße 30a <br />
    51067 Cologne, Germany
  </p>
  <p>
    Henry Wolf <br />
    Dollahner Straße 4b <br />
    18609 Ostseebad Binz, Germany
  </p>
  <p>
    Nils Alberding-Schulz <br />
    Walter Stöcker Straße 10 <br />
    18069 Rostock, Germany
  </p>
  <h3>Exploring the Board</h3>
  <p>
    Email: <br />
    felicia.primadita&#64;web.de <br />
    HWolf.binz&#64;gmail.com <br />
    nilsalberding&#64;web.de
  </p>
  <h3>Acceptance of terms</h3>
  <p>
    By accessing and using <span class="blue">Join</span> (Product), you acknowledge and agree to the
    following terms and conditions, and any policies, guidelines, or amendments
    thereto that may be presented to you from time to time. We, the listed
    students, may update or change the terms and conditions from time to time
    without notice.
  </p>
  <h3>Scope and ownership of the product</h3>
  <p>
    <span class="blue">Join</span> has been developed as part of a student group project in a web
    development bootcamp at the <span class="blue">Developer Akademie GmbH</span>. It has an educational
    purpose and is not intended for extensive personal & business usage. As
    such, we cannot guarantee consistent availability, reliability, accuracy, or
    any other aspect of quality regarding this Product.
  </p>
  <p>
    The design of <span class="blue">Join</span> is owned by the <span class="blue">Developer Akademie GmbH</span>. Unauthorized
    use, reproduction, modification, distribution, or replication of the design
    is strictly prohibited.
  </p>
  <h3>Proprietary rights</h3>
  <p>
    Aside from the design owned by <span class="blue">Developer Akademie GmbH</span>, we, the listed
    students, retain all proprietary rights in <span class="blue">Join</span>, including any associated
    copyrighted material, trademarks, and other proprietary information.
  </p>
  <h3>Use of the product</h3>
  <p>
    <span class="blue">Join</span> is intended to be used for lawful purposes only, in accordance with all
    applicable laws and regulations. Any use of <span class="blue">Join</span> for illegal activities, or
    to harass, harm, threaten, or intimidate another person, is strictly
    prohibited. You are solely responsible for your interactions with other
    users of Join.
  </p>
  <h3>Disclaimer of warranties and limitation of liability</h3>
  <p>
    <span class="blue">Join</span> is provided "as is" without warranty of any kind, whether express or
    implied, including but not limited to the implied warranties of
    merchantability, fitness for a particular purpose, and non-infringement. In
    no event will we, the listed students, or the Developer Akademie, be liable
    for any direct, indirect, incidental, special, consequential or exemplary
    damages, including but not limited to, damages for loss of profits,
    goodwill, use, data, or other intangible losses, even if we have been
    advised of the possibility of such damages, arising out of or in connection
    with the use or performance of <span class="blue">Join</span>.
  </p>
  <h3>Indemnity</h3>
  <p>
    You agree to indemnify, defend and hold harmless us, the listed students,
    the <span class="blue">Developer Akademie</span>, and our affiliates, partners, officers, directors,
    agents, and employees, from and against any claim, demand, loss, damage,
    cost, or liability (including reasonable legal fees) arising out of or
    relating to your use of <span class="blue">Join</span> and/or your breach of this Legal Notice.
  </p>
  <p>For any questions or notices, please contact us (see contact above).</p>
  <p>Date: July 26, 2023</p>
</section>
